"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeDiacritics = exports.isUrl = exports.getInitialsFromModel = exports.getInitials = exports.getFullname = exports.escapeStringRegexp = exports.capitalize = exports.alphabet = void 0;
var _deburr = _interopRequireDefault(require("lodash/deburr"));
var _escapeRegExp = _interopRequireDefault(require("lodash/escapeRegExp"));
var _memoize = _interopRequireDefault(require("lodash/memoize"));
var _merge = _interopRequireDefault(require("lodash/merge"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var alphabet = exports.alphabet = function alphabet() {
  var table = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  return table.split('');
};
var capitalize = exports.capitalize = (0, _memoize.default)(str => {
  if (!str) return '';
  return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
});
var escapeStringRegexp = str => (0, _escapeRegExp.default)(str);
exports.escapeStringRegexp = escapeStringRegexp;
var getFullname = exports.getFullname = function getFullname() {
  var {
    firstname,
    lastname
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 ? arguments[1] : undefined;
  if (!lastname && !firstname) return '';

  // handle opts
  var options = (0, _merge.default)({
    reverse: false,
    capitalize: true,
    upperCase: false,
    separator: ' ',
    lowerCase: false,
    initialize: false
  }, args);
  var initializeFirstname = options.initialize === true || options.initialize === 'firstname';
  var lowerCaseFirstname = !initializeFirstname && (options.lowerCase === true || options.lowerCase === 'firstname');
  var upperCaseFirstname = !lowerCaseFirstname && (options.upperCase === true || options.upperCase === 'firstname');
  var capitalizeFirstname = !upperCaseFirstname && !lowerCaseFirstname && (options.capitalize === true || options.capitalize === 'firstname');
  var firstnameStyled = firstname || '';
  if (initializeFirstname) {
    firstnameStyled = getInitials(firstnameStyled);
  }
  if (lowerCaseFirstname) {
    firstnameStyled = firstnameStyled.toLowerCase();
  }
  if (upperCaseFirstname) {
    firstnameStyled = firstnameStyled.toUpperCase();
  }
  if (capitalizeFirstname) {
    firstnameStyled = capitalize(firstnameStyled);
  }
  var initializeLastname = options.initialize === true || options.initialize === 'lastname';
  var lowerCaseLastname = !initializeLastname && (options.lowerCase === true || options.lowerCase === 'lastname');
  var upperCaseLastname = !lowerCaseLastname && (options.upperCase === true || options.upperCase === 'lastname');
  var capitalizeLastname = !upperCaseLastname && !lowerCaseLastname && (options.capitalize === true || options.capitalize === 'lastname');
  var lastnameStyled = lastname || '';
  if (initializeLastname) {
    lastnameStyled = getInitials(lastnameStyled);
  }
  if (lowerCaseLastname) {
    lastnameStyled = lastnameStyled.toLowerCase();
  }
  if (upperCaseLastname) {
    lastnameStyled = lastnameStyled.toUpperCase();
  }
  if (capitalizeLastname) {
    lastnameStyled = capitalize(lastnameStyled);
  }
  if (!lastname) return firstnameStyled;
  if (!firstname) return lastnameStyled;
  if (options.initialize === true) return "".concat(firstnameStyled).concat(lastnameStyled);
  if (options.reverse) return "".concat(lastnameStyled).concat(options.separator).concat(firstnameStyled);
  return "".concat(firstnameStyled).concat(options.separator).concat(lastnameStyled);
};
var getInitials = string => {
  if (!string) return '';
  if (/^[+#*0-9]*$/g.test(string)) {
    // it seems to be a phone number
    return '-';
  }
  var cleanString = removeDiacritics(string.trim()).toUpperCase().replace(/\W/g, ' ');
  var splitted = cleanString.split(' ').filter(e => e && e.trim().length);
  if (splitted.length >= 2) {
    return "".concat(splitted[0][0]).concat(splitted[splitted.length - 1][0]);
  }
  return cleanString[0];
};
exports.getInitials = getInitials;
var getInitialsFromModel = exports.getInitialsFromModel = (0, _memoize.default)(model => {
  if (model !== null && model !== void 0 && model.fullname) {
    return getInitials(model.fullname);
  } else if (model !== null && model !== void 0 && model.firstname && model !== null && model !== void 0 && model.lastname) {
    return getInitials("".concat(model.firstname, " ").concat(model.lastname));
  } else if (model !== null && model !== void 0 && model.firstname) {
    return getInitials(model.firstname);
  }
  return '-';
});
var isUrl = exports.isUrl = (0, _memoize.default)(str => {
  if (!str) return '';
  /* eslint-disable */
  return str.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm);
  /* eslint-enable */
});

var removeDiacritics = str => (0, _deburr.default)(str);
exports.removeDiacritics = removeDiacritics;